<template>
  <card>
    <h5 slot="header" class="title">Edit Profile</h5>
    <div class="row">
      <div class="col-md-4 pr-md-1">
        <fieldset disabled>
          <base-input label="Level of access"
                      v-model="profile.role.name"
                      placeholder="">
          </base-input>
        </fieldset>
      </div>
      <div class="col-md-4 px-md-1">
        <base-input label="Username"
                    v-model="profile.user.name"
                    placeholder="Login">
        </base-input>
      </div>
      <div class="col-md-4 pl-md-1">
        <base-input label="Email address"
                    v-model="profile.user.email"
                    placeholder="Email">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 pr-md-1">
        <base-input label="First Name"
                    v-model="profile.employee.first_name"
                    placeholder="First Name">
        </base-input>
      </div>
      <div class="col-md-6 pl-md-1">
        <base-input label="Last Name"
                    v-model="profile.employee.last_name"
                    placeholder="Last Name">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 pr-md-1">
        <fieldset disabled>
          <base-input label="Project"
                      v-model="profile.project.name"
                      placeholder="Project">
          </base-input>
        </fieldset>
      </div>
      <div class="col-md-3 px-md-1">
        <base-input label="SSN"
                    v-model="profile.employee.employeeSSN"
                    placeholder="Social Security Number">
        </base-input>
      </div>
      <div class="col-md-4 pl-md-1">
        <base-input label="Phone number"
                    v-model="profile.employee.phone"
                    placeholder="Phone number">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 pr-md-1">
        <base-input label="Profession"
                    v-model="profile.user.description"
                    placeholder="Profession">
        </base-input>
      </div>
      <div class="col-md-4 pl-md-1">
        <base-input label="Avatar"
                    v-model="profile.employee.avatar"
                    placeholder="default.png">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <fieldset disabled>
          <base-input label="Address of your Project"
                      v-model="profile.project.address.street"
                      placeholder="Street">
          </base-input>
        </fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 pr-md-1">
        <fieldset disabled>
          <base-input label="City"
                      v-model="profile.project.address.city"
                      placeholder="City">
          </base-input>
        </fieldset>
      </div>
      <div class="col-md-4 px-md-1">
        <fieldset disabled>
          <base-input label="Country"
                      v-model="profile.project.address.country"
                      placeholder="Country">
          </base-input>
        </fieldset>
      </div>
      <div class="col-md-4 pl-md-1">
        <fieldset disabled>
          <base-input label="Postal Code"
                      v-model="profile.project.address.code"
                      placeholder="ZIP Code">
          </base-input>
        </fieldset>
      </div>
    </div>
    <div class="row">
      <base-input>
        <label>About Me</label>
        <textarea rows="4" cols="80"
                  class="form-control"
                  placeholder=""
                  v-model="profile.employee.description">
        </textarea>
      </base-input>
    </div>
    <base-button simple slot="footer" type="primary" @click="sendProfile" fill>Save</base-button>
  </card>
</template>
<script>

  export default {
    props: ['profile'],
    name: 'edit-profile-form',
    data() {
      return {
      }
    },
    methods:{
      sendProfile(){
        this.$emit('update-employees');
      },
    },
    mounted() {}
  }
</script>
<style scoped>

</style>
